var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPc)?_c('div',{staticClass:"tome",style:({ bottom: _vm.offsetBottom + 'px' }),on:{"click":_vm.onBackHandle}}):_c('div',{staticClass:"tome",style:({ bottom: _vm.offsetBottom + 'px' }),on:{"touchstart":function($event){$event.preventDefault();return _vm.move.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }